// src/pages/ServicesPage.js
import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Card, CardContent, CircularProgress, Alert } from '@mui/material';
import axiosInstance from '../api/axios';

function ServicesPage() {
    const [opcionesAdicionales, setOpcionesAdicionales] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchOpciones = async () => {
            try {
                const response = await axiosInstance.get('/Reservas/opciones');
                setOpcionesAdicionales(response.data);
            } catch (err) {
                console.error("Error al cargar opciones adicionales:", err);
                setError("Error al cargar los servicios adicionales.");
            } finally {
                setLoading(false);
            }
        };
        fetchOpciones();
    }, []);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Alert severity="error" sx={{ my: 3 }}>
                {error}
            </Alert>
        );
    }

    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                Nuestros Servicios Adicionales
            </Typography>
            <Typography variant="body1" sx={{ mb: 4 }}>
                Nuestros Servicios Adicionales
            </Typography>

            <Grid container spacing={4}>
                {opcionesAdicionales.map((opcion) => (
                    <Grid item key={opcion.id} xs={12} sm={6} md={4}>
                        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    {opcion.nombre}
                                </Typography>
                                <Typography variant="body1" color="primary.main" sx={{ mb: 1 }}>
                                    ${opcion.precio.toFixed(2)}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Tipo: {opcion.tipo}
                                </Typography>
                                {/* Puedes añadir una descripción más detallada si la tienes en tu modelo */}
                                {/* <Typography variant="body2" sx={{ mt: 1 }}>
                                    {opcion.descripcion}
                                </Typography> */}
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

export default ServicesPage;